/* eslint-disable no-unused-expressions */
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { CardMessage } from 'fpay-ui';
import styled from 'styled-components';
import { useFundsOut } from "@hooks";
import parse from 'html-react-parser';
import { getEnv } from "@config";

import * as ROUTES from '@constants/routes';

const Container = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 48px;
  div > div:nth-child(2) > div:nth-child(2) {
      display: initial;
  }
  @media (min-width: 768px) {
    margin-top: 96px;
  }
  
`;

const SuccessFoundsOut = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const handleClick = () => {
    history.push(ROUTES.LAST_MOVEMENTS);
  };
  const { bankAccount } = useFundsOut();
  const { country } = getEnv();

  const isPeru = country === 'pe';
  const isColombia = country === 'co';
  let bankID = '';
  if (bankAccount) bankID = bankAccount.bank_data.finantial_institution_id;
  const bankName = bankAccount.bank_data.finantial_institution_name

  const isBankBCP = isPeru && bankID === '002';
  const isBankDavivienda = isColombia && bankID === '000051';

  const description = parse(t('paymentsFoundsOut.success.description', {
      bankName,
      hoursTime: isBankBCP ? '48' : '72',
      hoursTimeCo: isBankDavivienda ? '24' : '48',
    })
  );

  return (
    <Container>
      <CardMessage
        buttonText={t('paymentsFoundsOut.success.button')}
        title={t('paymentsFoundsOut.success.title')}
        subTitle={description}
        handleClick={handleClick}
        htmlIdButton="withdraw-money-funds-out-success-movements"
        htmlIdSuccessAnimation="withdraw-money-funds-out-success"
      />
    </Container>
  );
};

export default SuccessFoundsOut;
